/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_DieselInputs */

const en_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesel`)
};

const es_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diésel`)
};

const fr_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesel`)
};

const de_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesel`)
};

const ja_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ディーゼル`)
};

const zh_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`柴油`)
};

const ar_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ديزل`)
};

const id_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesel`)
};

const it_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesel`)
};

const ru_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дизель`)
};

const pt_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesel`)
};

const ko_val_diesel = /** @type {(inputs: Val_DieselInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`디젤(경유)`)
};

/**
* | output |
* | --- |
* | "Diesel" |
*
* @param {Val_DieselInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_diesel = /** @type {((inputs?: Val_DieselInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_DieselInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_diesel(inputs)
	if (locale === "es") return es_val_diesel(inputs)
	if (locale === "fr") return fr_val_diesel(inputs)
	if (locale === "de") return de_val_diesel(inputs)
	if (locale === "ja") return ja_val_diesel(inputs)
	if (locale === "zh") return zh_val_diesel(inputs)
	if (locale === "ar") return ar_val_diesel(inputs)
	if (locale === "id") return id_val_diesel(inputs)
	if (locale === "it") return it_val_diesel(inputs)
	if (locale === "ru") return ru_val_diesel(inputs)
	if (locale === "pt") return pt_val_diesel(inputs)
	return ko_val_diesel(inputs)
});